import { ChartCrumbsDTO } from './ChartCrumbsDTO';

export class SensorSeriesDTO {
    [key: string]: ChartCrumbsDTO
}
